"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWrapper = exports.ErrorWrapper = exports.ButtonWrapper = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
const {
  spacing
} = _uiKit.theme;
const ErrorWrapper = exports.ErrorWrapper = _styledComponents.default.div.withConfig({
  displayName: "ErrorMessagestyle__ErrorWrapper",
  componentId: "sc-9l5awu-0"
})(["display:flex;justify-content:center;align-items:center;margin:0;padding-top:8px;> div{color:", "}"], _uiKit.theme.colours.WHITE);
const ButtonWrapper = exports.ButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "ErrorMessagestyle__ButtonWrapper",
  componentId: "sc-9l5awu-1"
})(["margin-left:8px;"]);
const IconWrapper = exports.IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "ErrorMessagestyle__IconWrapper",
  componentId: "sc-9l5awu-2"
})(["display:inline-block;margin-right:", "px;"], spacing.BASE_1);